export default __webpack_public_path__ + "static/media/stratzy-partner.5c5a75e7.svg";